import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  imgSrc?: string;
  imgAlt?: string;
  imgClassName?: string;
  imgWidth?: number;
  imgHeight?: number;
}

const Button: React.FC<ButtonProps> = ({
  label,
  imgSrc,
  imgAlt,
  imgClassName,
  imgWidth,
  imgHeight,
  ...props
}) => {
  return (
    <button {...props}>
      {imgSrc && (
        <img
          src={imgSrc}
          width={imgWidth || 15}
          height={imgHeight || 15}
          alt={imgAlt || ""}
          className={imgClassName || "simple-icon"}
        />
      )}
      <span>{label}</span>
    </button>
  );
};

export default Button;
